/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/median.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * The value that is greater than half of all values and less than half of all values, also known as the 50% `PERCENTILE`.
 *
 * Note: Like `PERCENTILE`, `MEDIAN` is usually approximate.
 *
 * @example
 * FROM employees
 * | STATS MEDIAN(salary), PERCENTILE(salary, 50)
 *
 * @example
 * FROM employees
 * | STATS median_max_salary_change = MEDIAN(MV_MAX(salary_change))
 *
 * @example
 * TS exp_histo_sample
 * | WHERE instance == "instance-0"
 * | STATS p50 = ROUND(MEDIAN(responseTime), 4)
 *
 * @example
 * TS histogram_timeseries_index
 * | WHERE instance == "instance-0"
 * | STATS p50 = ROUND(MEDIAN(responseTime::tdigest), 2)
 */
const definition: FunctionDefinition = {
  type: 'agg',
  name: 'median',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'exponential_histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'tdigest',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
